// @flow
import * as React from 'react';

type Props = {
  children: React.Node,
};

export default ({ children }: Props) => (
  <div className="_Portal_LoginScreen_Wrapper_wrapper">
    {children}
  </div>
)